import {
  TOKEN_VERIFY,
  TOKEN_VERIFY_FAILURE,
  TOKEN_VERIFY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const tokenVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOKEN_VERIFY:
      return { ...state, loading: true };
    case TOKEN_VERIFY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case TOKEN_VERIFY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default tokenVerifyReducer;
